import http from './httpService';
import qs from 'qs';
import { getDeviceInfo } from './securityService';
import config from './../configs/config';

function generateURL(path) {
  return `${config.apiEndPoint}/${path}`;
}

const add_minutes = function (dt, minutes) {
  return new Date(dt.getTime() + minutes * 60000);
};

// 1. Sign-in with userid and password
export async function login(user) {
  localStorage.clear();
  const body = qs.stringify({
    username: user.username + '@' + config.domain,
    password: user.password
  });
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  };
  const device = await getDeviceInfo();
  const url =
    generateURL('token') +
    ('?device=' + device.device) +
    ('&os=' + device.os) +
    ('&keepmesignedin=' + user.terms);
  const { data } = await http.post(url, body, headers);
  let expiry = add_minutes(new Date(), 45).toString();
  localStorage.setItem('session', expiry);
  return data;
}

// 2. Refresh session
export async function refreshLogin() {
  await http.post(generateURL('refresh'));
}

// 3. Terminate session
export async function logout(page) {
  sessionStorage.clear();
  await http.get(generateURL('logout'));
}

// 4. reset your password
export async function resetPassword(data) {
  const body = qs.stringify({
    username: data.username + '@' + config.domain,
    password: data.password,
    new_password: data.new_password,
    confirm_password: data.confirm_password
  });
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  };
  let user = await http.post(generateURL('reset-password'), body, headers);
  return user;
}

// 5. Generate SSO URL & Redirect User
export async function sso_login() {
  const device = await getDeviceInfo();
  const meta = {
    auth_provider: 'azure-oidc',
    device: device.device,
    os: device.os
  };
  window.location =
    config.apiEndPoint +
    '/azure-login-token' +
    '?auth_provider=' +
    meta.auth_provider +
    '&device=' +
    meta.device +
    '&os=' +
    meta.os;
}
